export const CONFIGURATION_CANVAS_LEFT_PANEL_WIDTH = 380;
